import { render } from "./adminheader.vue?vue&type=template&id=14008ef8"
import script from "./adminheader.vue?vue&type=script&lang=js"
export * from "./adminheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__